/* Outdoors Nordic - lazy autoplay for video.
   Flyttad ur snippets/video.liquid 2026-10-07. Den renderades en gang per
   video och produktsidan har tolv, alltsa 51 kB upprepad kod i dokumentet.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
  if (window.__onLazyAutoplayVideo) return;
  window.__onLazyAutoplayVideo = 1;
  function mount(el) {
    if (el.__vidMounted || el.querySelector('video, iframe')) { el.__vidMounted = 1; return; }
    el.__vidMounted = 1;
    var tpl = el.querySelector('template');
    if (!tpl) return;
    el.appendChild(tpl.content.cloneNode(true));
    el.setAttribute('data-media-loaded', 'true');
    el.isPlaying = true;
    var btn = el.querySelector('.deferred-media__poster-button');
    if (btn) btn.style.display = 'none';
    var v = el.querySelector('video');
    if (v) {
      v.muted = true;
      // Horizon-komponenten kan skicka paus-event vid init – auto-resuma de första sekunderna
      var tries = 0;
      var resume = function () { if (tries++ < 6 && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
      v.addEventListener('pause', function () { setTimeout(resume, 250); });
      setTimeout(function () { tries = 99; }, 7000);
      resume();
    }
  }
  /*
    Produktgalleriet ar en HORISONTELL karusell: alla bilder ligger pa samma hojd
    men langt utanfor skarmen i sidled (left 750 ... 11625 pa en 375px-skarm).
    Den gamla kontrollen testade bara hojdled, sa varje bild passerade samtidigt
    och hela galleriet laddades ned direkt (uppmatt 103 MB pa en PDP 2026-08-19).
     inView() ar den egentliga fixen och testar BADA axlarna. IntersectionObserver
    ligger ovanpa som snabbare vackning, men mekanismen far aldrig hanga pa den
    ensam: den levererar inga callbacks i flikar som inte renderar, och karusellen
    kan flyttas med transform utan att nagot scroll-event fyrar.
  */
  /* Rutan maste vara FRAMME, inte "snart framme". Den gamla marginalen pa 400 px
     betydde i praktiken direkt pa mobil: galleriet ar en liggande karusell, sa
     slide 2 lag alltid inom marginalen och hela videon laddades vid sidladdning.
     Nu kravs att en dryg tredjedel av rutan syns pa BADA axlarna. */
  function inView(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var vw = window.innerWidth, vh = window.innerHeight;
    var x = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
    var y = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    return (x * y) / (r.width * r.height) >= 0.35;
  }
  /* Ingen video far konkurrera med forsta uppritningen. Allt slapps fram forst
     efter load, eller vid forsta interaktionen om load drojer. */
  var opened = false;
  var pending = false;
  function openGate() {
    if (opened) return;
    opened = true;
    if (pending) check();
  }
  var io = window.IntersectionObserver
    ? new IntersectionObserver(
        function (entries) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) {
              io.unobserve(entries[j].target);
              mount(entries[j].target);
            }
          }
        },
        { rootMargin: '0px', threshold: 0.35 }
      )
    : null;
  var ticking = false;
  function check() {
    ticking = false;
    if (!opened) { pending = true; return; }
    var els = document.querySelectorAll('deferred-media[data-lazy-autoplay]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__vidMounted) continue;
      if (inView(el)) {
        mount(el);
        continue;
      }
      if (io && !el.__vidWatched) {
        el.__vidWatched = 1;
        io.observe(el);
      }
    }
  }
  window.__onLazyAutoplayCheck = check;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(check);
    }
  }
  /* capture: karusellens egen scroll bubblar inte upp till window */
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', onScroll);
  /* Transform-driven karusell fyrar inget scroll-event: kolla efter varje
    interaktion, och nagra ganger efter laddning medan bilderna glider pa plats. */
  /* Efter trycket, inte i det (prestanda 2026-10-15): kollen mater layouten och hamnade
     forut i samma bildruta som trycket. 150 ms senare har sidan hunnit ritas. */
  function onTap() { setTimeout(onScroll, 150); }
  document.addEventListener('click', onTap, true);
  document.addEventListener('pointerup', onTap, { capture: true, passive: true });
  document.addEventListener('keyup', onTap, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
  /* Grinden oppnas efter load, eller vid forsta interaktionen om load drojer.
     Sedan far den vanliga synlighetskollen avgora vilka rutor som monteras. */
  if (document.readyState === 'complete') {
    setTimeout(openGate, 200);
  } else {
    window.addEventListener('load', function () { setTimeout(openGate, 200); });
  }
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) {
    window.addEventListener(ev, openGate, { once: true, capture: true, passive: true });
  });
  window.addEventListener('load', check);
  [1200, 2500].forEach(function (t) {
    setTimeout(check, t);
  });
})();
